import {useState, useEffect} from 'react';

import {history} from '../../helpers/history';
import StatusPopup, {StatusPopupType} from '../../com/statusPopup/StatusPopup'
import {useTypedSelector} from '../../hooks/useTypeSelector';
import {ErrorDto} from "../../dtos";

const ReduxErrorsHandler: React.FC = () => {
    const authState = useTypedSelector((state) => state.auth);
    const analyticsData = useTypedSelector((state) => state.analyticsData);
    const pagesState = useTypedSelector((state) => state.pages);
    const flyersState = useTypedSelector((state) => state.flyers);
    const flippingFlyerState = useTypedSelector((state) => state.flippingFlyer);
    const guiSettingsState = useTypedSelector((state) => state.guiSettings);
    const promosItemsState = useTypedSelector((state) => state.promotionsAndItems);
    const conversionUrlSetting = useTypedSelector((state) => state.conversionUrlSetting);
    const accountSettingsAndLang = useTypedSelector((state) => state.accountSettingWithLang)
    const flyerDataFromPdf = useTypedSelector((state) => state.flyerDataFromPdf)
    const flyerDataFromJpegs = useTypedSelector((state) => state.flyerDataFromJpegs)
    const flyerDataWithoutImages = useTypedSelector((state) => state.flyerDataWithoutImages)
    const tocForPage = useTypedSelector((state) => state.tocForPage)
    const spots = useTypedSelector((state) => state.spots);
    const flyerClasses = useTypedSelector((state) => state.flyerClasses);
    const downloadFileState = useTypedSelector((state) => state.downloadFileState);
    const storeSettingsState = useTypedSelector((state) => state.accountStoreSettings);
    const storeState = useTypedSelector((state) => state.storeForAccount);
    const usersState = useTypedSelector((state) => state.usersAndPermissions);
    const updatePasswordState = useTypedSelector((state) => state.updatePassword);

    const [title, setTitle] = useState('');
    const [subTitle, setSubTitle] = useState('');
    const [recommendation, setRecommendation] = useState('');

    const [errorDto, setErrorDto] = useState<ErrorDto | null>(null);
    const [show, setShow] = useState(false);
    const [popupType, setPopupType] = useState(StatusPopupType.ERROR)

    const handleClose = () => {
        setShow(false)

        setTitle('')
        setSubTitle('')
        setRecommendation('')

        setErrorDto(null)
    };

    const hasUnauthorizedError = (errorDto: ErrorDto) => {
        if (errorDto) {
            if (errorDto.languageCultureMessageResponseDto) {
                let messageResponseDto = errorDto.languageCultureMessageResponseDto

                let texts = [
                    messageResponseDto.title ? messageResponseDto.title.toLowerCase() : '',
                    messageResponseDto.recommendedAction ? messageResponseDto.recommendedAction.toLowerCase() : '',
                    messageResponseDto.userFriendlyMessage ? messageResponseDto.userFriendlyMessage.toLowerCase() : '',
                ];

                let hasUnauthorizedMessage = texts.some(text => text.includes('401') || text.includes('unauthorized'))

                if (hasUnauthorizedMessage) {
                    return true;
                }
            } else if (errorDto.technicalMessage) {
                let message = errorDto.technicalMessage!.toLowerCase();

                if (message.includes('401') ||
                    message.includes('unauthorized')) {
                    return true;
                }
            }
        }

        return false;
    }

    // const removeCarriageReturn = (text: string): string => {
    //     let filteredText = text.replace(/(\r\n)/gm,"");
    //     return filteredText;
    // }

    const splitStringBy = (text: string, splitter: string): string[] => {
        if (!text || text.trim().length === 0) {
            return []
        }

        return text.split(splitter);
    }

    useEffect(() => {

        let oldErrorDto = errorDto;
        let newErrorDto: ErrorDto | null = null;

        if (oldErrorDto) {
            // means that the current popup is still showing and has some errors inside of it
            // => dont try to close or change it
            if(oldErrorDto.languageCultureMessageResponseDto?.title?.indexOf('401') &&  oldErrorDto.languageCultureMessageResponseDto?.title?.indexOf('401') > 0){
                setErrorDto(null);
            }
            return;
        }

        if (authState.error) {
            newErrorDto = authState.error
        } else if (flippingFlyerState.error) {
            newErrorDto = flippingFlyerState.error
        } else if (promosItemsState.error) {
            newErrorDto = promosItemsState.error
        } else if (flyersState.error) {
            newErrorDto = flyersState.error
        } else if (guiSettingsState.error) {
            newErrorDto = guiSettingsState.error
        } else if (pagesState.error) {
            newErrorDto = pagesState.error
        } else if (analyticsData.error) {
            newErrorDto = analyticsData.error
        } else if (conversionUrlSetting.error) {
            newErrorDto = conversionUrlSetting.error
        } else if (spots.error) {
            newErrorDto = spots.error
        } else if (accountSettingsAndLang.error) {
            newErrorDto = accountSettingsAndLang.error
        } else if (flyerDataFromPdf.error) {
            newErrorDto = flyerDataFromPdf.error
        } else if (flyerDataFromJpegs.error) {
            newErrorDto = flyerDataFromJpegs.error
        } else if (flyerDataWithoutImages.error) {
            newErrorDto = flyerDataWithoutImages.error
        } else if (tocForPage.error) {
            newErrorDto = tocForPage.error
        } else if (flyerClasses.error) {
            newErrorDto = flyerClasses.error
        } else if (downloadFileState.error) {
            newErrorDto = downloadFileState.error
        } else if (storeSettingsState.error) {
            newErrorDto = storeSettingsState.error
        } else if (storeState.error) {
            newErrorDto = storeState.error
        } else if (usersState.error) {
            newErrorDto = usersState.error
        } else if (updatePasswordState.error) {
            newErrorDto = updatePasswordState.error
        }
        //
        if (newErrorDto && Object.keys(newErrorDto).length === 0) {
            newErrorDto = null;
        }

        //
        // if(newErrorsDto.errors!.length === 1){ 
        //     title = 'ERROR ' + newErrorsDto.errors![0].status
        // }
        // else {
        //     title = 'ERRORS'
        // }


        //
        /*if(newErrorsDto!.errors && newErrorsDto!.errors!.length > 0){
            title = 'INFO'
            setPopupType(StatusPopupType.INFO)
        }
        else {
            setPopupType(StatusPopupType.ERROR)
        }*/

        //
        if (newErrorDto?.languageCultureMessageResponseDto?.title !== "canceled") {
            let hasErrors = newErrorDto !== null
            if (newErrorDto !== null) {
                setErrorDto(newErrorDto);
                setPopupType(StatusPopupType.INFO);
                if (newErrorDto.languageCultureMessageResponseDto && newErrorDto.languageCultureMessageResponseDto?.title === 'Network Error') {
                    setRecommendation("Site temporarily not available. Please try again soon.");
                    setShow(hasErrors);
                } else if (newErrorDto.languageCultureMessageResponseDto
                    && newErrorDto.languageCultureMessageResponseDto?.title
                    && newErrorDto.languageCultureMessageResponseDto?.title?.indexOf("404") > -1)
                {
                    //handler for 404
                    setRecommendation(newErrorDto.languageCultureMessageResponseDto?.title);
                    setShow(hasErrors);
                } else if (hasUnauthorizedError(newErrorDto!)) {
                    // setTitle("Unauthorized")

                    // navigate to login screen => reset errors list
                    newErrorDto!.diagnostics = [];

                    localStorage.removeItem('userDto')
                    history.push('/')
                } else {
                    setRecommendation(newErrorDto.userFriendlyMessage!.toString());
                    setShow(hasErrors);
                    // setRecommendation(newErrorDto.userFriendlyMessage! === '' ? newErrorDto.data.toString() : newErrorDto.userFriendlyMessage!.toString());
                }
                // let languageCultureMessage = newErrorDto.languageCultureMessageResponseDto!
                //
                // setTitle(languageCultureMessage && languageCultureMessage!.title ? languageCultureMessage!.title! : '')
                // setSubTitle(languageCultureMessage && languageCultureMessage!.recommendedAction ? languageCultureMessage!.recommendedAction! : '')
                // setRecommendation(languageCultureMessage && languageCultureMessage!.userFriendlyMessage ? languageCultureMessage!.userFriendlyMessage!.trim() : '')
                // if (hasUnauthorizedError(newErrorDto!)) {
                //     setTitle("Unauthorized")
                //
                //     // navigate to login screen => reset errors list
                //     newErrorDto!.diagnostics = [];
                //
                //     localStorage.removeItem('userDto')
                //     history.push('/')
                // }
            }
        }

    }, [
        authState.error,
        flippingFlyerState.error,
        flyersState.error,
        guiSettingsState.error,
        pagesState.error,
        promosItemsState.error,
        conversionUrlSetting.error,
        spots.error,
        accountSettingsAndLang.error,
        analyticsData.error,
        flyerDataFromPdf.error,
        tocForPage.error,
        flyerClasses.error,
        flyerDataFromJpegs.error,
        flyerDataWithoutImages.error,
        downloadFileState.error,
        storeSettingsState.error,
        storeState.error,
        usersState.error,
        updatePasswordState.error,
    ])

    const setting = {
        modalName: "error"
    }

    return (
        <StatusPopup
            settings={setting}
            type={popupType}
            title={title}
            subTitle={subTitle}
            messages={splitStringBy(recommendation, "\r\n")}
            show={show}
            handleClose={handleClose}
        />
    )
}

export default ReduxErrorsHandler;